import type { Point } from 'geojson'

export interface StrictPoint extends Point {
	coordinates: [number, number]
}

export const strictPoint = (point: Point | [number, number]): StrictPoint => {
	if (Array.isArray(point)) {
		return { type: 'Point', coordinates: point }
	} else {
		if (point.coordinates.length !== 2) throw new Error('Coordinates must have length of 2')
		return point as StrictPoint
	}
}
